import { Routes, Route } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Layout from "./components/layout";
import './App.scss';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dashboard from "./pages/Dashboard/Dashboard";
import LoginPage from "./pages/Auth/Login";
import ResetPasswordPage from "./pages/Auth/ResetPassword";
import ForgotPasswordPage from "./pages/Auth/ForgotPassword";
import AtsPage from "./pages/ATS/atsPage";
import { PrivateRoute } from "./components/PrivateRoute";
import MasterData from "./pages/MasterData/MasterData";
import AlertsData from "./pages/Alerts/Alerts";
import ExternalPage from "./pages/ExternalPage/ExternalPage";
import ExternalSuccess from "./pages/ExternalPage/ExternalSuccess";
import ApplicantBoardPage from "./pages/Applicant/ApplicantBoard";
import SettingsPage from "./pages/Settings/settings";
import CareerPage from "./pages/careerPage/careerPage";
import PageNotFound from "./components/common/noDatafound/PageNotFound";
import PrivacyPolicy from "./components/layout/PrivacyPolicy";
import TermsConditions from "./components/layout/TermsConditions";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import ReferralJobProfile from './pages/Referral/ReferralJobProfile';
import Progress from "./components/common/Loader/Progress";


const Router = [
  {
    path: "/",
    component: <Dashboard />,
  },
  {
    path: "/openings",
    component: <AtsPage />,
  },
  {
    path: "/applicants",
    component: <ApplicantBoardPage />,
  },
  {
    path: "/applicants/:jobid",
    component: <ApplicantBoardPage />,
  },
  {
    path: "/master-data",
    component: <MasterData />,
  },
  {
    path: "/referral-profile",
    component: <ReferralJobProfile/>,
  },
  {
    path: "/alerts",
    component: <AlertsData />,
  },
  {
    path: "/settings",
    component: <SettingsPage />,
  },
];

function App() {
  const [isPvtRoute, setIsPvtRoute] = useState(null);

  useEffect(() => {
    if (window.location.hostname === 'ats.gloify.in' || 
    window.location.hostname === 'localhost' || 
    window.location.hostname === 'ats-fe.s3-website.ap-south-1.amazonaws.com' || 
    window.location.hostname === 'atsqa.gloify.in') {
      setIsPvtRoute(true);
    } else {
      setIsPvtRoute(false);
    }
  }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          {Router.map((item, index) => (
            <Route
              key={index}
              path={item.path}
              index={item.index}
              element={
                <React.Suspense fallback={<>...</>}>
                  {item.component}
                </React.Suspense>
              }
            />
          ))}
        </Route>
        {isPvtRoute && 
        <>
          <Route path="/refer" element={<Progress/>}/>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ResetPasswordPage />} />
          <Route path="/ResetPassword/:token" element={<ForgotPasswordPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsConditions />} />
        </>
        }
        <Route path="/application" element={<ExternalPage />} />
        <Route path="/application/:externalId/:job" element={<ExternalPage />} />
        <Route path="/external-success" element={<ExternalSuccess />} />
        <Route path="/careers" element={<CareerPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;
